import api from '@/services/Api';
import { UserDetail } from '@/models/UserDetail'

class AccountService {

  async getPaginatedAccountList(search, sort, order, page, limit, filters) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''
    const url = '/distributor/account/list' +
      '?search=' + encodeURIComponent(search) +
      '&sort=' + sort +
      '&order=' + order +
      '&page=' + page +
      '&limit=' + limit +
      '&filters=' + filters;
    const response = await api.get(url)
    return response.data
  }

  async updateAccountProfile(data) {
    const response = await api.put('/account', data)
    return new UserDetail(response.data)
  }

  async updateAccountPassword(data) {
    const response = await api.put('/account/update-password', data)
    return response.data
  }

  async getAccount(accountId) {
    const response = await api.get('/distributor/account/' + accountId)
    return response.data
  }

  async updateAccount(data) {
    const response = await api.put('/distributor/account', data)
    return response.data
  }
}

export default new AccountService()
